// extracted by mini-css-extract-plugin
export default {"tooltip":"Tooltip_tooltip__mkS9z","arrow":"Tooltip_arrow__6v63S"};